// Core
import React, { useState, useRef, useEffect } from "react";

// Styles
import "./styles.scss";

// Assets
import dropDownIcon from "../../Assets/Images/dropDownLogo.png";

const CustomDropdown = ({
  label,
  name,
  value,
  options,
  onChange,
  required = false,
  dropdownStyle = {},
  labelStyle = {},
  inputStyle = {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleDropdownClick = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (optionValue) => {
    onChange({ target: { name, value: optionValue } });
    setIsOpen(false);
  };

  // Function to handle clicks outside the dropdown
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    // Attach the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup the event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="custom-dropdown-container"
      style={dropdownStyle}
      ref={dropdownRef}
    >
      {label && (
        <label htmlFor={name} style={labelStyle}>
          {label}
          {required && " *"}
        </label>
      )}
      <div
        className="dropdown"
        style={inputStyle}
        onClick={handleDropdownClick}
      >
        {value
          ? options.find((opt) => opt.value === value)?.label
          : "Select an option"}
        <div className="dropdown-arrow">
          <img src={dropDownIcon} alt="dropDown" />
        </div>
      </div>
      {isOpen && (
        <ul className="dropdown-options">
          {options.map((option, index) => (
            <li
              key={index}
              className="dropdown-option"
              onClick={() => handleOptionClick(option.value)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
